import { gql, useMutation } from '@apollo/client';

import { GET_EMAIL_TEMPLATES } from './get-email-templates.hook';

export const DELETE_EMAIL_TEMPLATE_BY_ID = gql`
  mutation deleteEmailTemplateById($emailTemplateId: String!) {
    deleteEmailTemplateById(emailTemplateId: $emailTemplateId) {
      _id
    }
  }
`;

export const useDeleteEmailTemplateById = ({ onSuccess }: { onSuccess: () => void }) => {
  const [deleteEmailTemplateById] = useMutation(DELETE_EMAIL_TEMPLATE_BY_ID, {
    refetchQueries: [GET_EMAIL_TEMPLATES],
    onCompleted: onSuccess,
  });

  return deleteEmailTemplateById;
};
